export default "__VITE_PUBLIC_ASSET__fde0a2a9__"